import { BroadcastChannel } from 'broadcast-channel';
/**
 * Singleton instance that manages multiple broadcast channels
 */
class AlucioChannel {
    constructor() {
        this.commonChannels = {
            PDF_CHANNEL: 'PDF_CHANNEL',
            PRESENTATION_CHANNEL: 'PRESENTATION_CHANNEL',
        };
        this.channels = {};
    }
    get(name) {
        if (!this.channels[name]) {
            this.channels[name] = new BroadcastChannel(name);
        }
        return this.channels[name];
    }
    async remove(name) {
        if (!this.channels[name]) {
            throw new Error(`Channel ${name} does not exist`);
        }
        await this.channels[name].close();
        delete this.channels[name];
    }
}
export default new AlucioChannel();
//# sourceMappingURL=broadcastChannel.web.js.map